/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { Typography, Typography2 } from '@coursera/cds-core';
import { CheckIcon } from '@coursera/cds-icons';

import _t from 'i18n!nls/teams-v2';

function ValuePropItem({ text }: { text: JSX.Element }) {
  return (
    <div css={{ display: 'flex', marginBottom: 'var(--cds-spacing-100)' }}>
      <div css={{ width: 16, paddingTop: 2 }}>
        <CheckIcon color="interactive" size="small" />
      </div>
      <Typography2 component="p" css={{ marginLeft: 'var(--cds-spacing-200)' }}>
        {text}
      </Typography2>
    </div>
  );
}

function TeamsValuePropItem() {
  return (
    <div
      css={{ marginTop: 'var(--cds-spacing-200)', padding: `var(--cds-spacing-200) var(--cds-spacing-300)` }}
      data-testid="teams-value-prop-item"
    >
      <Typography variant="h2" css={{ marginBottom: 'var(--cds-spacing-200)' }}>
        {_t('Transform your talent')}
      </Typography>
      <ValuePropItem
        text={
          <FormattedMessage
            message={_t('{highlightText} to the Coursera catalog')}
            highlightText={<strong>{_t('Unlimited access')}</strong>}
          />
        }
      />
      <ValuePropItem
        text={
          <FormattedMessage
            message={_t('{highlightText} content recommendations')}
            highlightText={<strong>{_t('Personalized')}</strong>}
          />
        }
      />
      <ValuePropItem
        text={
          <FormattedMessage
            message={_t('Learner {highlightText}')}
            highlightText={<strong>{_t('usage and progress tracking tools')}</strong>}
          />
        }
      />
      <ValuePropItem
        text={
          <FormattedMessage
            message={_t('{highlightText} credentials')}
            highlightText={<strong>{_t('Industry-recognized')}</strong>}
          />
        }
      />
    </div>
  );
}

export default TeamsValuePropItem;
